// extracted by mini-css-extract-plugin
export default {"addScrollStyles":"global_addScrollStyles__0t1RZ"};